import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/* tslint:disable */
/* eslint-disable */
/**
 * View API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import { ViewFromJSON, ViewEnumerationResultFromJSON } from '../models/index';

/**
 * ViewReaderApi - interface
 * 
 * @export
 * @interface ViewReaderApiInterface
 */

/**
 * 
 */
export var ViewReaderApi = /*#__PURE__*/function (_runtime$BaseAPI) {
  function ViewReaderApi() {
    _classCallCheck(this, ViewReaderApi);
    return _callSuper(this, ViewReaderApi, arguments);
  }
  _inherits(ViewReaderApi, _runtime$BaseAPI);
  return _createClass(ViewReaderApi, [{
    key: "getViewRaw",
    value: (
    /**
     * Get a view by RID value
     */
    function () {
      var _getViewRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(requestParameters, initOverrides) {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!(requestParameters['encodedViewRID'] == null)) {
                _context.next = 2;
                break;
              }
              throw new runtime.RequiredError('encodedViewRID', 'Required parameter "encodedViewRID" was null or undefined when calling getView().');
            case 2:
              queryParameters = {};
              headerParameters = {};
              if (requestParameters['xBffCsrf'] != null) {
                headerParameters['x-bff-csrf'] = String(requestParameters['xBffCsrf']);
              }
              if (!(this.configuration && this.configuration.accessToken)) {
                _context.next = 9;
                break;
              }
              _context.next = 8;
              return this.configuration.accessToken("OAuth2-Test", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 8:
              headerParameters["Authorization"] = _context.sent;
            case 9:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context.next = 13;
                break;
              }
              _context.next = 12;
              return this.configuration.accessToken("OAuth2-Stage", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 12:
              headerParameters["Authorization"] = _context.sent;
            case 13:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context.next = 17;
                break;
              }
              _context.next = 16;
              return this.configuration.accessToken("OAuth2-Prod", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.packaging"]);
            case 16:
              headerParameters["Authorization"] = _context.sent;
            case 17:
              _context.next = 19;
              return this.request({
                path: "/views/{encodedViewRID}".replace("{".concat("encodedViewRID", "}"), encodeURIComponent(String(requestParameters['encodedViewRID']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters
              }, initOverrides);
            case 19:
              response = _context.sent;
              return _context.abrupt("return", new runtime.JSONApiResponse(response, function (jsonValue) {
                return ViewFromJSON(jsonValue);
              }));
            case 21:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getViewRaw(_x, _x2) {
        return _getViewRaw.apply(this, arguments);
      }
      return getViewRaw;
    }()
    /**
     * Get a view by RID value
     */
    )
  }, {
    key: "getView",
    value: (function () {
      var _getView = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(requestParameters, initOverrides) {
        var response;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return this.getViewRaw(requestParameters, initOverrides);
            case 2:
              response = _context2.sent;
              _context2.next = 5;
              return response.value();
            case 5:
              return _context2.abrupt("return", _context2.sent);
            case 6:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function getView(_x3, _x4) {
        return _getView.apply(this, arguments);
      }
      return getView;
    }()
    /**
     * Get a shared view by Id and enclosing containerRID
     */
    )
  }, {
    key: "getViewByIdRaw",
    value: (function () {
      var _getViewByIdRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(requestParameters, initOverrides) {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(requestParameters['encodedContainerRID'] == null)) {
                _context3.next = 2;
                break;
              }
              throw new runtime.RequiredError('encodedContainerRID', 'Required parameter "encodedContainerRID" was null or undefined when calling getViewById().');
            case 2:
              if (!(requestParameters['encodedViewId'] == null)) {
                _context3.next = 4;
                break;
              }
              throw new runtime.RequiredError('encodedViewId', 'Required parameter "encodedViewId" was null or undefined when calling getViewById().');
            case 4:
              queryParameters = {};
              headerParameters = {};
              if (requestParameters['xBffCsrf'] != null) {
                headerParameters['x-bff-csrf'] = String(requestParameters['xBffCsrf']);
              }
              if (!(this.configuration && this.configuration.accessToken)) {
                _context3.next = 11;
                break;
              }
              _context3.next = 10;
              return this.configuration.accessToken("OAuth2-Test", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 10:
              headerParameters["Authorization"] = _context3.sent;
            case 11:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context3.next = 15;
                break;
              }
              _context3.next = 14;
              return this.configuration.accessToken("OAuth2-Stage", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 14:
              headerParameters["Authorization"] = _context3.sent;
            case 15:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context3.next = 19;
                break;
              }
              _context3.next = 18;
              return this.configuration.accessToken("OAuth2-Prod", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.packaging"]);
            case 18:
              headerParameters["Authorization"] = _context3.sent;
            case 19:
              _context3.next = 21;
              return this.request({
                path: "/views/byId/{encodedContainerRID}/{encodedViewId}".replace("{".concat("encodedContainerRID", "}"), encodeURIComponent(String(requestParameters['encodedContainerRID']))).replace("{".concat("encodedViewId", "}"), encodeURIComponent(String(requestParameters['encodedViewId']))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters
              }, initOverrides);
            case 21:
              response = _context3.sent;
              return _context3.abrupt("return", new runtime.JSONApiResponse(response, function (jsonValue) {
                return ViewFromJSON(jsonValue);
              }));
            case 23:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function getViewByIdRaw(_x5, _x6) {
        return _getViewByIdRaw.apply(this, arguments);
      }
      return getViewByIdRaw;
    }()
    /**
     * Get a shared view by Id and enclosing containerRID
     */
    )
  }, {
    key: "getViewById",
    value: (function () {
      var _getViewById = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4(requestParameters, initOverrides) {
        var response;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return this.getViewByIdRaw(requestParameters, initOverrides);
            case 2:
              response = _context4.sent;
              _context4.next = 5;
              return response.value();
            case 5:
              return _context4.abrupt("return", _context4.sent);
            case 6:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this);
      }));
      function getViewById(_x7, _x8) {
        return _getViewById.apply(this, arguments);
      }
      return getViewById;
    }()
    /**
     * Get a view by its container RID.
     * Get a view by its container RID
     */
    )
  }, {
    key: "queryViewsRaw",
    value: (function () {
      var _queryViewsRaw = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(requestParameters, initOverrides) {
        var queryParameters, headerParameters, response;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (!(requestParameters['containerRID'] == null)) {
                _context5.next = 2;
                break;
              }
              throw new runtime.RequiredError('containerRID', 'Required parameter "containerRID" was null or undefined when calling queryViews().');
            case 2:
              queryParameters = {};
              if (requestParameters['containerRID'] != null) {
                queryParameters['containerRID'] = requestParameters['containerRID'];
              }
              if (requestParameters['metadata'] != null) {
                queryParameters['metadata'] = requestParameters['metadata'];
              }
              headerParameters = {};
              if (requestParameters['xBffCsrf'] != null) {
                headerParameters['x-bff-csrf'] = String(requestParameters['xBffCsrf']);
              }
              if (!(this.configuration && this.configuration.accessToken)) {
                _context5.next = 11;
                break;
              }
              _context5.next = 10;
              return this.configuration.accessToken("OAuth2-Test", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 10:
              headerParameters["Authorization"] = _context5.sent;
            case 11:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context5.next = 15;
                break;
              }
              _context5.next = 14;
              return this.configuration.accessToken("OAuth2-Stage", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.delete", "solutionviewengine:viewcontent.write", "solutionviewengine:view.packaging"]);
            case 14:
              headerParameters["Authorization"] = _context5.sent;
            case 15:
              if (!(this.configuration && this.configuration.accessToken)) {
                _context5.next = 19;
                break;
              }
              _context5.next = 18;
              return this.configuration.accessToken("OAuth2-Prod", ["solutionviewengine:view.read", "solutionviewengine:view.write", "solutionviewengine:view.packaging"]);
            case 18:
              headerParameters["Authorization"] = _context5.sent;
            case 19:
              _context5.next = 21;
              return this.request({
                path: "/views",
                method: 'GET',
                headers: headerParameters,
                query: queryParameters
              }, initOverrides);
            case 21:
              response = _context5.sent;
              return _context5.abrupt("return", new runtime.JSONApiResponse(response, function (jsonValue) {
                return ViewEnumerationResultFromJSON(jsonValue);
              }));
            case 23:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this);
      }));
      function queryViewsRaw(_x9, _x10) {
        return _queryViewsRaw.apply(this, arguments);
      }
      return queryViewsRaw;
    }()
    /**
     * Get a view by its container RID.
     * Get a view by its container RID
     */
    )
  }, {
    key: "queryViews",
    value: (function () {
      var _queryViews = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(requestParameters, initOverrides) {
        var response;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) switch (_context6.prev = _context6.next) {
            case 0:
              _context6.next = 2;
              return this.queryViewsRaw(requestParameters, initOverrides);
            case 2:
              response = _context6.sent;
              _context6.next = 5;
              return response.value();
            case 5:
              return _context6.abrupt("return", _context6.sent);
            case 6:
            case "end":
              return _context6.stop();
          }
        }, _callee6, this);
      }));
      function queryViews(_x11, _x12) {
        return _queryViews.apply(this, arguments);
      }
      return queryViews;
    }())
  }]);
}(runtime.BaseAPI);